import { Modal, ModalHeading, Card } from "@biteship/atom";
import { ChevronLeftIcon, ChevronRightIcon } from "../../../images/icons";

export default function ModalImages(props) {
  const revokeObjectURL = () => {
    URL.revokeObjectURL(props.images[props.activeImage]);
  };
  return (
    <Modal
      show={props.show}
      className="md:max-w-3xl w-full md:px-16 md:py-8 py-4 px-8"
      onClose={() => {
        props.onClose();
        if (props.from === "createModal") revokeObjectURL();
      }}
    >
      <ModalHeading
        title="Dokumen Pendukung"
        onClose={() => {
          props.onClose();
          if (props.from === "createModal") revokeObjectURL();
        }}
        className="py-2 px-0"
      />
      <img
        src={
          props.from === "createModal"
            ? URL.createObjectURL(props.images[props.activeImage])
            : props.images[props.activeImage]
        }
        alt="Foto Telah Kadaluarsa"
        className="w-full text-center mt-4"
      />
      <div className="flex justify-center space-x-4 items-center mt-4">
        <ChevronLeftIcon
          className={`w-6 h-6 flex-shrink-0 cursor-pointer ${
            props.activeImage === 0 ? "text-gray-700" : "text-gray-900"
          }`}
          onClick={() => {
            if (props.activeImage > 0) {
              if (props.from === "createModal") revokeObjectURL();
              props.setActiveImage(props.activeImage - 1);
            }
          }}
          aria-hidden
        />
        <div className="text-xs">
          {props.activeImage + 1} dari {props.images.length} Foto
        </div>
        <ChevronRightIcon
          className={`w-6 h-6 flex-shrink-0 cursor-pointer ${
            props.activeImage === props.images.length - 1 ? "text-gray-700" : "text-gray-900"
          }`}
          onClick={() => {
            if (props.activeImage < props.images.length - 1) {
              if (props.from === "createModal") revokeObjectURL();
              props.setActiveImage(props.activeImage + 1);
            }
          }}
          aria-hidden
        />
      </div>
    </Modal>
  );
}
